import { addDoc, collection } from 'firebase/firestore';
import { db } from '../firebase/firebase';
import { auth } from '../firebase/firebase';

export const seedCustomers = async () => {
  if (!auth.currentUser) {
    throw new Error('User must be logged in to seed data');
  }
  
  const userId = auth.currentUser.uid;
  const customersCollectionRef = collection(db, 'customers');
  
  const sampleCustomers = [
    { 
      name: 'John Doe', 
      email: 'john@example.com', 
      phone: '555-123-4567',
      userId: userId,
      updatedAt: new Date(),
      status: 'active',
      tags: ['VIP', 'Regular']
    },
    { 
      name: 'Jane Smith', 
      email: 'jane@example.com', 
      phone: '555-765-4321',
      userId: userId,
      updatedAt: new Date(),
      status: 'active',
      tags: ['Newsletter']
    },
    { 
      name: 'Robert Johnson', 
      email: 'robert@example.com', 
      phone: '555-987-6543',
      userId: userId,
      updatedAt: new Date(),
      status: 'inactive',
      tags: ['Former Client']
    },
    { 
      name: 'Emily Davis', 
      email: 'emily@example.com', 
      phone: '555-456-7890',
      userId: userId,
      updatedAt: new Date(),
      status: 'active',
      tags: ['New', 'Referral']
    },
    { 
      name: 'Michael Wilson', 
      email: 'michael@example.com', 
      phone: '555-321-6547',
      userId: userId,
      updatedAt: new Date(),
      status: 'active',
      tags: ['Corporate', 'VIP']
    }
  ];
  
  const promises = sampleCustomers.map(customer => addDoc(customersCollectionRef, customer));
  await Promise.all(promises);
  
  console.log('Sample customers added to Firestore');
};

// To use this function, import it in a component and call it:
// import { seedCustomers } from '../utils/seedData';
// seedCustomers();
